import * as React from 'react';
import { EMPTY_TEXT, Modal, Select, LabelValuePair } from '@mitchell/react.component.ux';
import { TranslationService } from "../../../common";
import { IntelligentAssignmentSummary } from '../../constants';
import { useIdentifyAsGroupSelection } from '../../hooks';
import { StyledIdentifyModalBody } from './IntelligentAssignmentSummaryComponent.style';
export const AssignmentSummaryGroupSelectionModalComponent = ({ cancelButtonId, confirmButtonId, countryCode, groupLabel, groupOptions, initialGroup, isOpen, modalId, onCancel, onConfirm, selectId, selectPlaceholderLabel, title, customOptionComponent }) => {
    const { selectedGroup, setSelectedGroup } = useIdentifyAsGroupSelection({
        countryCode,
        groupOptions,
        initialGroup,
        isOpen
    });
    const selectedOption = groupOptions.find(option => option.value === selectedGroup);
    const selectPlaceholderOption = {
        label: selectPlaceholderLabel,
        value: EMPTY_TEXT
    };
    const selectOptions = [selectPlaceholderOption, ...groupOptions];
    const selectedValue = selectedOption
        ? { label: selectedOption.label, value: selectedOption.value }
        : selectPlaceholderOption;
    const handleSelectChange = (option) => {
        setSelectedGroup(option.value);
    };
    const confirmButton = {
        id: confirmButtonId,
        label: TranslationService.translate(IntelligentAssignmentSummary.DONE_BUTTON_LABEL),
        onClick: () => {
            if (selectedOption) {
                onConfirm(selectedOption.value);
            }
        },
        disabled: !selectedOption
    };
    const cancelButton = {
        id: cancelButtonId,
        label: TranslationService.translate(IntelligentAssignmentSummary.IDENTIFY_AS_MODAL_CANCEL_LABEL),
        onClick: onCancel
    };
    return (React.createElement(Modal, { id: modalId, isOpen: isOpen, title: title, isLightbox: false, maxWidth: "xs", primaryBtn: confirmButton, tertiaryBtn: cancelButton, shouldHideScroll: true, onClose: onCancel },
        React.createElement(StyledIdentifyModalBody, null,
            React.createElement(LabelValuePair, { label: groupLabel },
                React.createElement(Select, { id: selectId, value: selectedValue, options: selectOptions, onChange: handleSelectChange, customOptionComponent: customOptionComponent })))));
};
//# sourceMappingURL=IntelligentAssignmentSummaryIdentifyPhotosToGroupModalComponent.js.map